import { defineAsyncComponent } from 'vue'

const components = import.meta.glob('../components/Base*.vue', { eager: true })
const componentNameReg = /\/([^/]*)\.vue/

export function loadVueBaseComponents(app) {
  Object.keys(components).forEach((fileName) => {
    // Get component config
    const componentConfig = components[fileName]
    // Get PascalCase name of component
    const componentName = componentNameReg[Symbol.match](fileName)[1]
    // Globally register the component
    app.component(componentName, componentConfig.default)
  })
}
